<template>
  <Modal v-if="shows" transitionType="up-down" classNames="share_pop" :class="{ slide_down: shows }" @close="close()">
    <template v-slot:header>공유하기</template>

    <div class="share_wrap">
      <a target="_blank" :href="facebookUrl" class="fb-xfbml-parse-ignore">
        <button type="button" @click="crmGoodsDetailFacebookShare">
          <i class="facebook" />
          <span class="txt_hidden">facebook으로 공유하기</span>
        </button></a
      >

      <button type="button" @click="crmGoodsDetailKakaotalkShare();shareKakao();">
        <i class="kakao" />
        <span class="txt_hidden">kakao로 공유하기</span>
      </button>

      <button type="button" :id="clipboardButtonId" :data-clipboard-text="url" @click="crmGoodsDetailUrlShare">
        <i class="url" />
        <span class="txt_hidden">url 복사</span>
      </button>
    </div>
  </Modal>
</template>

<script>
import { computed, defineComponent, onBeforeUnmount, unref, watch } from '@vue/composition-api';
import { useStore } from '@vueblocks/vue-use-vuex';
import ClipboardJS from 'clipboard';
import { v4 as uuid } from 'uuid';
import AlarmMsg from '@/utils/alarmMsg';

import { useRoute } from '@/utils/hooks';
import Modal from '@/components/common/Modal';

import { 
  crmGoodsDetailFacebookShare,
  crmGoodsDetailKakaotalkShare,
  crmGoodsDetailUrlShare
  } from '@/helpers/ad/crm/crm.js'

export default defineComponent({
  components: {
    Modal,
  },

  setup() {
    const store = useStore();

    const route = useRoute();

    const clipboardButtonId = computed(() => `id_${uuid()}`);

    const shows = computed(() => store.getters['share/shows']);
    const url = computed(() => store.getters['share/url']);
    const title = computed(() => store.getters['share/title']);
    const text = computed(() => store.getters['share/text']);
    const imageUrl = computed(() => store.getters['share/imageUrl']);

    const close = () => store.dispatch('share/hide');

    const clipboard = new ClipboardJS(`#${unref(clipboardButtonId)}`);
    clipboard.on('success', async () => {
      await AlarmMsg.showMsg('클립보드에 복사되었습니다.');
      close();
    });
    onBeforeUnmount(() => {
      clipboard.destroy();
    });

    watch(route, () => close());

    return {
      clipboardButtonId,

      shows,
      url,
      title,
      text,

      facebookUrl: computed(() => `http://www.facebook.com/sharer.php?u=${window.encodeURIComponent(unref(url))}&t=${window.encodeURIComponent(unref(text))}`),

      shareKakao() {
        window.Kakao.Link.sendDefault({
          objectType: 'feed',
          content: {
            /** 콘텐츠의 타이틀 */
            title: unref(title),

            /** 콘텐츠의 이미지 URL */
            imageUrl: unref(imageUrl),

            /** 콘텐츠 클릭 시 이동할 링크 정보 */
            link: {
              /** PC 버전 카카오톡에서 사용하는 웹 링크 URL */
              webUrl: unref(url),
              /** 모바일 카카오톡에서 사용하는 웹 링크 URL */
              mobileWebUrl: unref(url),

              /** 안드로이드 카카오톡에서 사용하는 앱 링크 URL에 사용될 파라미터 */
              // androidExecutionParams: '',

              /** iOS 카카오톡에서 사용하는 앱 링크 URL에 사용될 파라미터 */
              // iosExecutionParams: '',
            },
            /** 콘텐츠의 상세 설명 */
            description: unref(text),
          },
        });
      },
      close,

      crmGoodsDetailFacebookShare,
      crmGoodsDetailKakaotalkShare,
      crmGoodsDetailUrlShare
    };
  },
});
</script>
